import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['targetedMainCityText', 'activityFreeNameText']

  onActivityFreeNameChange(event) {
    this.activityFreeNameTextTargets.forEach(element => {
      element.innerHTML = event.currentTarget.value
    })
  }

  onTargetedMainCityChange(event) {
    this.targetedMainCityTextTargets.forEach(element => {
      element.innerHTML = event.currentTarget.options[event.currentTarget.selectedIndex].text
    })
  }
}
